<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M30.4032 11.1743C31.4032 9.17659 32.7507 8.12881 33.8918 7.29377C34.5114 6.83985 34.4403 5.77727 33.9166 5.50424C33.5306 5.30287 32.5307 5.15953 31.726 4.75566C30.8468 4.31425 30.1538 3.61573 29.5827 3.5304C28.1686 3.31766 27.4192 4.67602 26.3447 4.73632C25.5355 4.78182 24.9768 4.45646 24.0751 4.73973C23.1756 5.02301 23.2422 6.01163 23.6315 7.29491C24.0762 8.75907 24.8109 10.2449 25.6642 11.1686"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M17.2444 26.5295C16.8945 25.3179 16.8945 24.5306 16.8945 23.9584C16.8945 17.7422 22.655 10.7832 28.0678 10.7832C33.4807 10.7832 39.2411 18.319 39.2411 24.4954C39.2411 24.4954 39.2513 24.9448 39.2197 25.3543"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M13.7289 46.0463L5.43359 35.4069L10.3623 31.5025C11.071 30.9405 12.0981 31.0645 12.6556 31.7801L20.6564 42.0417L15.3541 46.242C14.8508 46.6401 14.1228 46.5525 13.7278 46.0451L13.7289 46.0463Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M20.082 40.9471L32.2688 39.954C34.0216 39.7549 34.3726 39.5046 35.5554 38.351L44.2243 28.9733C44.705 28.4534 44.6768 27.6388 44.1611 27.1542C42.9625 26.029 41.1081 26.0177 39.8971 27.128L36.0429 30.6627L35.7179 30.9608"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M24.053 35.1335L32.3777 34.51C33.2738 34.4429 33.9566 33.6739 33.925 32.7683C33.8765 31.3883 32.74 30.303 31.371 30.328L25.2889 30.4418C25.2889 30.4418 23.123 27.8286 18.6819 28.1835C15.7927 28.4145 14.2973 29.6067 12.6055 31.435"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M15.5463 41.7693C15.5463 41.9093 15.4335 42.023 15.2947 42.023C15.1558 42.023 15.043 41.9093 15.043 41.7693C15.043 41.6294 15.1558 41.5156 15.2947 41.5156C15.4335 41.5156 15.5463 41.6294 15.5463 41.7693Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M25.8995 24.2376C26.4401 24.5379 26.9807 24.7859 27.9852 24.7859C30.1634 24.7859 30.4817 23.5743 30.4817 23.059C30.4817 22.5436 30.2458 21.2364 27.9852 20.9532C25.693 20.6665 25.6523 19.4651 25.6523 19.0715C25.6523 18.6403 25.921 17.3184 27.9852 17.3184C28.7527 17.3184 29.2097 17.5277 29.6104 17.7461"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M27.9844 24.7852V26.1549"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M27.9844 15.9668V17.3195"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M31.7249 4.75586C31.7249 4.75586 31.0454 5.50899 30.1211 6.77975"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M26.3438 4.73633C26.3438 4.73633 26.4668 5.70334 26.6993 6.66921"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 50,
		height: 50,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
